// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sms-shipping .delivery-sms-send-time .v-text-field__slot>input{background-color:var(--v-secondary-lighten1)!important}.sms-shipping .delivery-sms-send-time.v-text-field>.v-input__control>.v-input__slot:before{border-color:var(--v-primary-base)!important}.delivery-sms-datetime-picker .v-btn{padding:0!important}.sms-sending-time-actions .v-btn{padding:0 24px!important;min-width:40px!important}", ""]);
// Exports
module.exports = exports;
